import CarouselContainer from "../../../Components/BonusUi/Carousel/Carousel";

const Carousel = () => {
  return (
    <div className="page-body">
      <CarouselContainer />
    </div>
  );
};

export default Carousel;
